import { List } from '@radix-ui/react-tabs'
import { cva, type VariantProps } from 'class-variance-authority'
import { forwardRef } from 'react'
import { cn } from '#src/cn.ts'

export const tabsListVariants = cva('inline-flex items-center justify-center', {
  variants: {
    variant: {
      default:
        'gap-1 rounded-md bg-frame p-1 text-frame-foreground shadow-inner',
      underline: [
        '[&>button[role=tab]]:border-b-2',
        '[&>button[role=tab]]:border-b-transparent',
        '[&>button[data-state=active][role=tab]]:text-teal-600',
        '[&>button[data-state=active][role=tab]]:border-b-teal-600',
        '[&>button[data-state=active][role=tab]]:rounded-none',
      ],
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export interface TabsListProps
  extends
    React.ComponentPropsWithoutRef<typeof List>,
    VariantProps<typeof tabsListVariants> {}

export const TabsList = forwardRef<
  React.ElementRef<typeof List>,
  TabsListProps
>(({ className, variant, ...props }, ref) => (
  <List
    ref={ref}
    className={cn(tabsListVariants({ variant, className }))}
    {...props}
  />
))
TabsList.displayName = List.displayName
